module.exports = __webpack_public_path__ + "static/img/client1.c3c70757.jpeg";